/**
 * Determines if a given value is numeric.
 * @param {*} value - The value to check. Can be any type.
 * @returns {boolean} - True if the value is numeric, false if it is not.
 */
export default function isNumeric(value) {
  return value === Number(parseFloat(value));
}



// WEBPACK FOOTER //
// ./app/utils/number/isNumeric.js